/**
 * Core module: exposes the engine kernel (clock, scheduler, log) as services
 * and owns the frame loop.
 */
import { AnimationFrameScheduler, FrameLoop } from "./FrameLoop";
import type { FrameScheduler } from "./FrameLoop";
import { defineModule } from "./module";

export interface CoreOptions {
  /** requestAnimationFrame in the browser, ManualFrameScheduler in tests. */
  readonly frames: FrameScheduler;
  /** How long ambient animation (VFX) runs without input before the loop idles. */
  readonly idleTimeoutMs: number;
}

export const CoreModule = defineModule({
  name: "Core",
  dependsOn: [],
  options: (): CoreOptions => ({ frames: new AnimationFrameScheduler(), idleTimeoutMs: 10_000 }),
  init: ({ kernel, options }) => {
    const frameLoop = new FrameLoop({
      clock: kernel.clock,
      frames: options.frames,
      idleTimeoutMs: options.idleTimeoutMs,
    });

    return {
      clock: kernel.clock,
      scheduler: kernel.scheduler,
      log: kernel.log,
      frameLoop,
    };
  },
  shutdown: ({ frameLoop }) => {
    frameLoop.setPaused(true);
  },
});
